// Constants for DebugPanel
export const DEFAULT_WIDTH = 78;
export const DEFAULT_HEIGHT = 42;
export const SNAP_THRESHOLD = 350;
export const CLICK_DURATION_MS = 200;
export const CLICK_DISTANCE_PX = 5;
export const PADDING = 10;
